<template>
  <div>
    <div class="aboutClass wrapper" v-if="companyDesc">
      <v-layout justify-center>
        <v-flex class="wrapper-inner">
          <p class="aboutLead" :style="{ color: mainColor }">
            {{ companyDesc.aboutLead }}
          </p>
          <v-img
            :src="require('@/assets/campus.jpg')"
            max-height="200"
            height="200"
            :aspect-ratio="3 / 1"
          ></v-img>
          <v-layout justify-center>
            <v-flex :class="$vuetify.breakpoint.smAndDown ? 'xs11' : 'xs7'">
              <v-card-text
                class="aboutText"
                v-html="companyDesc.aboutHeader"
              ></v-card-text>
              <v-card-text
                class="aboutDetails"
                v-html="companyDesc.aboutDetail"
              ></v-card-text>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <errorDialog :mainColor="mainColor" v-model="error"></errorDialog>
  </div>
</template>

<script>
import { log } from '../http-common.js'
import { AWS_HTTP } from '../http-common'

export default {
  name: 'About',
  data: () => ({
    error: false,
    companyDesc: null,
  }),
  components: {
    errorDialog: () =>
      import(/* webpackPrefetch: true */ '../components/error-dialog.vue'),
  },
  props: {
    routeName: String,
    mainColor: String,
    entity: Object,
    company: Object,
  },
  created() {
    AWS_HTTP.get('company', {
      cache: false,
      params: {
        companyId: this.company.companyId,
        timeStamp: new Date().getTime(),
      },
    })
      .then((response) => {
        let body = JSON.parse(response.data.body)
        this.companyDesc = body[0]
      })
      .catch((e) => {
        log(e.toString(), true, "About.vue created")
        this.error = true
      })
  },
  computed: {},
}
</script>

<style scoped>
.aboutClass {
  padding-top: 20px;
}
.aboutLead {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-weight: bold;

  font-size: 34px;
}
.aboutText {
  padding-top: 20px;
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: 18px;
  font-weight: bold;
}
.aboutDetails {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: 18px;
}
.wrapper {
  display: flex;
}
.wrapper-inner {
  flex-basis: 100%;
}
</style>